export default __webpack_public_path__ + "assets/5f103c3fe6823d44eb0323bd6c6fe5a3.png";